export default "__VITE_ASSET__0XE8Fvdf__"